// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Rqwp","overflowing":"ReadFullNote_overflowing__3aDBL"};